import { css } from '@emotion/css';

import {
  Colors,
  FontSize,
  FontWeight,
  SMALL_DEVICE_MQ,
  Spacing,
} from 'apps/shared/scripts/styles/constants';

export const giphyClassName = css({
  display: 'block',
});

export const searchbarClassName = css({});

export const inputClassName = css({
  border: '2px solid #F5F5F5',
  borderRadius: 8,
  color: Colors.Primary,
  fontSize: FontSize.REGULAR,
  fontWeight: FontWeight.NORMAL,
  minHeight: 50,
  padding: `${Spacing.XS}px ${Spacing.MD}px`,
  width: '100%',

  '&:focus': {
    borderColor: Colors.Primary,
  },

  '&::-webkit-input-placeholder': {
    /* Chrome/Opera/Safari */
    color: '#8f959d',
  },
  '&::-moz-placeholder': {
    /* Firefox 19+ */
    color: '#8f959d',
  },
  '&:-ms-input-placeholder': {
    /* IE 10+ */
    color: '#8f959d',
  },
  '&:-moz-placeholder': {
    /* Firefox 18- */
    color: '#8f959d',
  },
});

export const resultsClassName = css({
  height: 185,
  marginTop: Spacing.LG,
  '& img': {
    borderRadius: 4,
  },
  [SMALL_DEVICE_MQ]: {
    marginTop: Spacing.MD,
  },
});

export const overlayClassName = css({
  borderRadius: 4,
  position: 'absolute',
  left: 0,
  top: 0,
  right: 0,
  bottom: 0,
  display: 'flex',
  color: Colors.White,
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  transition: '0.2s',
  '&:hover': {
    background: 'rgba(0, 0, 0, 0.25)',
  },
});
